const originalAlpha = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const cipher = 'nopqrstuvwxyzabcdefghijklmNOPQRSTUVWXYZABCDEFGHIJKLM';

/**
 * @param str token string
 * @param isEncode isEncode = true => Encode,  isEncode = false => Decode
 * @returns A token string was encoded or decoded using ROT13.
 */
const rot13Transfer = (str: string, isEncode: boolean): string => {
    return str.replace(/[a-z]/gi, (letter) =>
        isEncode ? cipher[originalAlpha.indexOf(letter)] : originalAlpha[cipher.indexOf(letter)],
    );
};

/**
 * @param str token string
 * @param isEncode isEncode = true => Encode,  isEncode = false => Decode
 * @returns A token string was encoded or decoded using Base64.
 */
const base64Encode = (str: string, isEncode: boolean): string => {
    return isEncode ? window.btoa(str) : window.atob(str);
};

export const encodeToken = (token: string): string => {
    token = rot13Transfer(token, true);
    token = base64Encode(token, true);
    return token;
};

export const decodeToken = (token: string): string => {
    token = base64Encode(token, false);
    token = rot13Transfer(token, false);
    return token;
};
